import { render, staticRenderFns } from "./IntegrationHelpText.vue?vue&type=template&id=36f146e2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f146e2')) {
      api.createRecord('36f146e2', component.options)
    } else {
      api.reload('36f146e2', component.options)
    }
    module.hot.accept("./IntegrationHelpText.vue?vue&type=template&id=36f146e2&", function () {
      api.rerender('36f146e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrations/IntegrationHelpText.vue"
export default component.exports